import { Box } from '@mui/material';
import { observer } from 'mobx-react';
import React from 'react';

import { IUnitCardModel } from '../../../../../service/unit/interface/IUnitCardModel';
import { UnitCardHeader } from './UnitCardHeader';
import { UnitCardLangs } from './UnitCardLangs';
import { UnitCardStats } from './UnitCardStats';

const CARD_COLORS = {
  baseColor: 'rgba(144, 202, 249, 0.03)',
  color: '#FFFFFF',
  borderColor: 'rgba(144, 202, 249, 0.08)',
  progressColor: '#90CAF9',
  hoverColor: 'rgba(144, 202, 249, 0.08)',
};

export interface IUnitListAdminCardProperties {
  unit: IUnitCardModel;
  handleEdit: (unitId: string) => void;
  handleDelete: (unitId: string) => void;
  handlePublish: (unitId: string) => void;
  handleUnpublish: (unitId: string) => void;
}

export const UnitListAdminCard = observer(
  ({ unit, handleEdit, handleDelete, handlePublish, handleUnpublish }: IUnitListAdminCardProperties) => {
    return (
      <Box
        sx={{
          background: CARD_COLORS.baseColor,
          borderColor: CARD_COLORS.borderColor,
          borderWidth: '1px',
          borderStyle: 'solid',
          borderRadius: '16px',
          position: 'relative',
          paddingRight: '16px',
          cursor: 'pointer',
          '&:hover': {
            background: CARD_COLORS.hoverColor,
          },
        }}
      >
        <Box id={unit.id} sx={{ display: 'flex', alignItems: 'center' }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', flex: '0 0 70%' }}>
            <Box sx={{ padding: '24px 24px 0 24px', minHeight: '168px', paddingBottom: '32px' }}>
              <UnitCardHeader
                unit={unit}
                handleEdit={handleEdit}
                handleDelete={handleDelete}
                handlePublish={handlePublish}
                handleUnpublish={handleUnpublish}
              />
              <Box sx={{ opacity: 0.7, marginBottom: '32px' }}>{unit.settings.description}</Box>
              <UnitCardStats unit={unit} />
              {unit?.practice?.isEnabled && <UnitCardLangs unit={unit} />}
            </Box>
          </Box>

          <Box
            sx={{
              flex: '0 0 30%',
              height: '185px',
              position: 'relative',
              overflow: 'hidden',
            }}
          >
            <img
              src={unit.settings.preview?.data || '/pictures/unit-cover-default.png'}
              alt="unit-cover"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                position: 'absolute',
                top: 0,
                left: 0,
              }}
            />
          </Box>
        </Box>
      </Box>
    );
  },
);
